import repository from '@/repositories/Repository'

const resource = '/api/menus'

export default {
  get() {
    return repository.giggle.get(resource).then(r => r.data)
  },
}
